export default {
  catalogExport: {
    path: "/accounts/:accountId/catalog-export",
    name: "catalog-export",
  },
  catalogImportsList: {
    path: "/accounts/:accountId/catalog-imports",
    name: "catalogImportsList",
  },
};
